<!--考试说明-->
<template>
  <div class="content">
    <div class="top-bj"></div>
    <div class="main-box">
      <div class="top-line"></div>
      <div class="content-box">
        <div class="title" v-html="detailData.title"></div>
        <!-- <div class="h3">考试说明</div> -->
        <div class="p" v-html="detailData.desc" style="margin-top:30px;"></div>
        <div class="startAnswering" @click="startAnswering" v-if="isStart">{{$store.state.formType === 1?'立即开始':'立即答题'}}</div>
      </div>
    </div>

    <Modal
        class="modal1"
        v-model="modal1"
        :mask-closable="false"
        :closable="false"
        title="提示"
        width="200">
      <p slot="header">
        <Icon type="ios-alert-outline"/>
        <span>提示</span>
      </p>
      {{ modal1Text }}
    </Modal>
  </div>
</template>

<script>
import {formDetail, formSetting, cmsLogin} from "../../api/Interface";

export default {
  name: "explain",
  data() {
    return {
      detailData: {},
      isStart: true,
      modal1: false,
      modal1Text: ''
    }
  },
  created() {
    // this.getUrlParams()
    this.getLogin()
  },
  mounted() {
    this.$store.commit('isSubmit', false)
    // this.getFormDetail()
  },
  methods: {
    //获取登录信息
    getLogin() {
      let _this = this
      let ua = navigator.userAgent.toLowerCase();//获取判断用的对象
      if (ua.match(/mediacloudclient/i) == 'mediacloudclient') {
        //在app内打开
        this.getUrlParams()
        formSetting(this.$route.query.id).then(res => {
          if (res.state) {
            this.$store.commit('settingData', res.data);
            //判断是否需要登录
            if (res.data.base.login_limit&&!res.data.base.login_code_limit) {
              //需要登录
              // 在app内打开
              mc.userGetEncryptInfo(function (data) {
                //已登录
                if (data.state == 1) {
                  let params = {
                    userid: data.data.userid,
                    timestamp: data.data.timestamp,
                    nonce: data.data.nonce,
                    sign: data.data.signature,
                    form_id: _this.$route.query.id
                  }
                  cmsLogin(params).then(res => {
                    if (res.state) {
                      _this.$store.commit('isToken', true)
                      sessionStorage.setItem('token', 'Bearer' + res.data.token)
                      _this.getFormDetail()
                    } else {
                      _this.$Message.error(res.error);
                    }
                  }).catch(error => {
                    console.log(error);
                  })

                } else if (data.state == 0) {
                  // 未登录
                  mc.userLogin(function (data) {
                    if (data.state == 1) {
                      mc.userGetEncryptInfo(function (data2) {
                        if (data2.state == 1) {
                          let params = {
                            userid: data2.data.userid,
                            timestamp: data2.data.timestamp,
                            nonce: data2.data.nonce,
                            sign: data2.data.signature,
                            form_id: _this.$route.query.id
                          }
                          cmsLogin(params).then(res => {
                            if (res.state) {
                              _this.$store.commit('isToken', true)
                              sessionStorage.setItem('token', 'Bearer' + res.data.token)
                              _this.getFormDetail()
                            } else {
                              _this.$Message.error(res.error);
                            }
                          }).catch(error => {
                            console.log(error);
                          })
                        }
                      });
                    }
                  });
                }
              });
            } else {
              _this.getFormDetail()
            }
          }
        })
      } else {
        this.getFormDetail()
      }
    },
    //获取详情
    getFormDetail() {
      let data = {
        form_id: this.$route.query.id,
      }
      if (this.$store.state.code !== '') {
        data.code = this.$store.state.code
      }
      formDetail(data).then(res => {
        if (res.state) {
          this.detailData = res.data
          this.$store.commit('formTitle', res.data.title)
          this.$store.commit('formType', res.data.type)
          this.isStart = true;
          if(this.$route.query.id == '1304'){
            this.startAnswering()
          }
        } else {
          this.isStart = false
          this.modal1Text = res.error
          this.modal1=true;
        }
      }).catch(error => {
        console.log(error);
      })
    },
    //立即答题
    startAnswering() {
      /*重置答案*/
      this.$store.commit('user_answers', {})
      /*type为1 问卷类型    其他则为答题类型*/
      if(this.$store.state.formType ===1){
        this.$router.push('/activity?id=' + this.$route.query.id)
      }else{
        this.$router.push('/answer?id=' + this.$route.query.id)
      }
    },
    //获取网址参数
    getUrlParams() {
      var url = window.location.href; //获取当前url
      var cs = url.split('?')[1];//获取?之后的参数字符串
      var cs_arr = cs.split('&');//参数字符串分割为数组
      var cs = {};
      for (var i = 0; i < cs_arr.length; i++) {//遍历数组，拿到json对象
        cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1];
      }
      this.$store.commit('formId', cs.id);//这样就拿到了参数中的数据
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
  .top-bj {
    width: 100%;
    height: 130px;
    background: url("../../assets/images/top_bj.png") no-repeat top;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .main-box {
    height: calc(100% - 45px);
    background-color: #fcfcfc;
    position: absolute;
    top: 45px;
    left: 0;
    right: 0;
    bottom: 0;

    .top-line {
      height: 20px;
      background: #1a4bff;
      border: 4px solid #256eff;
      border-radius: 11px;
      box-shadow: 0 3px 6px 0 rgba(0, 53, 157, 0.62);
      margin: 10px 10px 0 10px;
      position: relative;
      z-index: 999;
    }

    .content-box {
      position: absolute;
      top: 8px;
      left: 5px;
      right: 5px;
      bottom: 0;
      z-index: 999;
      background: url("../../assets/images/duan_c_bj.png") no-repeat;
      background-size: cover;
      background-position: top;
      padding: 0 34px 30px 34px;
      display: flex;
      flex-direction: column;


      .title {
        font-size: 20px;
        color: #303133;
        text-align: center;
        font-weight: bold;
        margin-top: 35px;
      }

      .h3 {
        font-size: 18px;
        color: #303133;
        font-weight: bold;
        margin-top: 55px;
        position: relative;

        &:before {
          content: "";
          display: block;
          width: 2px;
          height: 20px;
          background-color: #1a4bff;
          position: absolute;
          left: -20px;
          top: 2px;
        }
      }

      .p {
        color: #606266;
        font-size: 15px;
        line-height: 28px;
        margin-top: 15px;
        margin-bottom: 20px;
        overflow-y: auto;
        flex: 1;
        word-break: break-all;
      }

      .startAnswering {
        width: 100%;
        height: 50px;
        background: linear-gradient(270deg, #3760f4, #6286fc);
        border-radius: 4px;
        font-size: 20px;
        color: #fff;
        text-align: center;
        line-height: 50px;
        //margin-bottom: 100px;
      }
    }
  }
}

/deep/ .ivu-modal {
  width: 280px !important;
  margin: auto;
}

/deep/ .ivu-modal-header {
  border-bottom: none;
}

/deep/ .ivu-modal-body {
  font-size: 16px;

  p {
    display: flex;
    align-items: center;

    .iconfont {
      color: #ee9900;
      font-size: 24px;
      margin-right: 5px;
    }
  }

}

/deep/ .ivu-modal-footer {
  display: none;
}

.modal1 {
  p {
    i {
      font-size: 20px;
      color: #ee9900;
      margin-right: 5px;
      font-weight: bold;
    }
  }
}

.downloadModal /deep/ .ivu-modal-footer {
  display: block;
  padding: 0px;
  height: 50px;

  > div {
    display: flex;
    align-items: center;
    height: 100%;
    text-align: center;
    line-height: 50px;

    > div {
      width: 50%;
      height: 100%;
    }
  }
}

.downloadModal /deep/ .ivu-modal-header {
  padding-bottom: 0px;
  color: #494949;;
}
</style>
